import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language?.startsWith('it') ? 'it' : 'en';
  return (
    <footer className="bg-white dark:bg-dark-bg text-[#1e1e1e] dark:text-dark-text py-4 mt-8">
      <div className="container mx-auto text-center">
        <div className="flex justify-center space-x-6">
          <Link to={`/${lang}/termini`} className="hover:text-gray-400 dark:hover:text-gray-300">{lang === 'it' ? 'Termini e condizioni' : 'Terms and conditions'}</Link>
          <Link to={`/${lang}/privacy`} className="hover:text-gray-400 dark:hover:text-gray-300">Privacy</Link>
          <Link to={`/${lang}/cookie`} className="hover:text-gray-400 dark:hover:text-gray-300">Cookie</Link>
        </div>
        <div className="mt-4">
          <p>&copy; {new Date().getFullYear()} FastAffiliation. {lang === 'it' ? 'Tutti i diritti riservati.' : 'All rights reserved.'}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
